import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '../assets/order_query_icon.png';
const _hoisted_1 = {
  style: {
    "margin": "16px"
  }
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1,
  class: "order_div"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_van_cell = _resolveComponent("van-cell");
  return _openBlock(), _createElementBlock("div", null, [_cache[4] || (_cache[4] = _createElementVNode("header", null, [_createElementVNode("img", {
    src: _imports_0,
    style: {
      "width": "0.5rem"
    }
  }), _createElementVNode("span", null, "订单查询")], -1)), _createElementVNode("div", null, [_createVNode(_component_van_form, {
    onSubmit: _cache[2] || (_cache[2] = $event => $options.queryOrder())
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, {
      inset: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: $data.adOrder.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.adOrder.name = $event),
        name: "开户人姓名",
        label: "开户人姓名",
        placeholder: "请输入下单时填写的开户人姓名",
        rules: [{
          required: true,
          message: '请填写下单时填写的开户人姓名'
        }]
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: $data.adOrder.phone,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.adOrder.phone = $event),
        name: "联系电话",
        label: "联系电话",
        placeholder: "请输入下单时填写的联系电话",
        rules: [{
          required: true,
          message: '请填写下单时填写的联系电话'
        }]
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_button, {
      round: "",
      block: "",
      type: "danger",
      "native-type": "submit"
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode(" 查询 ")])),
      _: 1
    })])]),
    _: 1
  })]), $data.adOrders != null && $data.adOrders.length != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.adOrders, order => {
    return _openBlock(), _createBlock(_component_van_cell_group, {
      inset: "",
      key: order.id,
      style: {
        "margin": "0.2rem"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell, {
        title: "订单类型",
        value: order.orderType
      }, null, 8, ["value"]), order.orderType == '号卡订单' ? (_openBlock(), _createBlock(_component_van_cell, {
        key: 0,
        title: "办理号码",
        value: order.phoneNumber
      }, null, 8, ["value"])) : order.orderType == '宽带订单' ? (_openBlock(), _createBlock(_component_van_cell, {
        key: 1,
        title: "宽带账号",
        value: order.phoneNumber
      }, null, 8, ["value"])) : _createCommentVNode("", true), _createVNode(_component_van_cell, {
        title: "下单时间",
        value: order.createTime
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "订单状态",
        value: order.status
      }, null, 8, ["value"]), order.expressComponey != null && order.expressComponey != '' && order.status == '下单成功' ? (_openBlock(), _createBlock(_component_van_cell, {
        key: 2,
        title: "物流信息",
        value: order.expressComponey + ' ' + order.expressNo
      }, null, 8, ["value"])) : _createCommentVNode("", true), order.status == '下单失败' ? (_openBlock(), _createBlock(_component_van_cell, {
        key: 3,
        title: "失败原因",
        value: order.remark
      }, null, 8, ["value"])) : _createCommentVNode("", true)]),
      _: 2
    }, 1024);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_3, " 没有查询到任何订单哦 "))]);
}